<template>
  <div class="flex items-center">
    <!-- Ürün Görselleri Stack -->
    <div class="flex -space-x-4">
      <template v-for="(item, index) in displayItems" :key="index">

        <div class="relative min-w-10 min-h-10 rounded-full border-2 bg-gray-100 overflow-hidden " :class="{
          'z-[3]': index === 0,
          'z-[2]': index === 1,
          'z-[1]': index === 2
        }">

          <NuxtImg v-if="item.image" fit="inside" width="50" height="50" :src="'cl' + item.image?.path"
            loading="lazy" />
          <div v-else class="w-full h-full flex items-center justify-center">
            <UIcon name="i-heroicons-photo" class="w-5 h-5 text-gray-400" />
          </div>
        </div>
      </template>

      <!-- Eğer daha fazla ürün varsa -->
      <div v-if="remainingCount > 0"
        class="relative z-0 w-10 h-10 rounded-full border-2 border-white bg-gray-50 flex items-center justify-center text-xs font-medium text-gray-500 ring-1 ring-gray-100">
        +{{ remainingCount }}
      </div>
    </div>

    <!-- Ürün Özeti -->
    <div class="ml-4">
      <p class="text-sm text-gray-700">
        {{ summaryText }}
      </p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  items: {
    type: Array,
    required: true
  }
})

// İlk 3 ürünü göster
const displayItems = computed(() => {
  return props.items.slice(0, 3)
})

// Kalan ürün sayısı
const remainingCount = computed(() => {
  return Math.max(0, props.items.length - 3)
})

// Özet metin
const summaryText = computed(() => {
  const totalItems = props.items.reduce((sum, item) => sum + item.quantity, 0)
  return `${totalItems} ürün`
})
</script>
